/* The idea of this file is to gather all links used by live that are noretrieved from the backend */
const imageLink = {
  thereWasAnError: 'https://res.cloudinary.com/hbrrdozyj/image/upload/v1641939475/ups_y5wobo.svg',
  helpCenter: 'https://help.cliengo.com/hc/es/articles/360044633033--Qu%C3%A9-archivos-no-puedo-enviar-ni-recibir-en-WhatsApp-mediante-Cliengo-',
};

export default imageLink;
